import { showErrorPage } from './actions';
import { NOTFOUND_ERROR_MSG } from './errors';
import { logError, logWarn } from './logging-utils';

export const handleServerError = ({ req, res, service, product, error }) => {
  logError(req, 'data-fetch-failure', {
    service,
    productId: product.id,
    category: product.category,
    product_type: product?.productType,
    error,
  });

  // TODO remove if we get a custom interstitial error page
  if (res) {
    res.status(500);
  }
};

export const handleNotFound = ({ req, res, service, product }) => {
  logWarn(req, NOTFOUND_ERROR_MSG, {
    service,
    productId: product.id,
    category: product.category,
    productType: product?.productType,
  });

  if (res) {
    res.status(404);
  }
};

export const handleInvalidOverride = ({
  req,
  res,
  service,
  product,
  error,
}) => {
  logWarn(req, 'invalid-override-query-param', {
    service,
    productId: product.id,
    category: product.category,
    override: product.override,
    product_type: product?.productType,
    error,
  });

  if (res) {
    res.status(404);
  }
};

export const handleInvalidTemplate = ({
  req,
  res,
  service,
  product,
  error,
}) => {
  logWarn(req, 'invalid-template', {
    service,
    productId: product.id,
    product_type: product?.productType,
    error,
  });

  if (res) {
    res.status(404);
  }
};

export default ({ req, res, store, service }) => ({
  handleServerError: ({ product, error }) => {
    handleServerError({ req, res, store, service, product, error });
    store.dispatch(showErrorPage());
  },
  handleNotFound: ({ product }) => {
    handleNotFound({ req, res, store, service, product });
    store.dispatch(showErrorPage());
  },
  handleInvalidOverride: ({ product, error }) => {
    handleInvalidOverride({ req, res, store, service, product, error });
    store.dispatch(showErrorPage());
  },
  handleInvalidTemplate: ({ product, error }) => {
    handleInvalidTemplate({ req, res, store, service, product, error });
    store.dispatch(showErrorPage());
  },
});
